import { Injectable } from '@angular/core';
import * as BrowserCore from 'scripts/browser-detection/src/browser-detection-shared.js';
import { BrowserInfo } from './browser-support.model';

@Injectable({ providedIn: 'root' })
export class BrowserSupportDetectionService {
  
  detectBrowser(): BrowserInfo | null {
    const result = BrowserCore.detectBrowser();
    
    if (!result) {
      return null;
    }
    
    return {
      name: result.name,
      version: result.version,
      isSupported: result.isSupported,
      isRecommended: result.isRecommended,
      recommendedVersion: result.recommendedVersion
    };
  }
  
  getRecommendedBrowsersList(): string {
    return BrowserCore.getRecommendedList();
  }
}
